export const CLEAR_PRODUCT_LIST = 'fulcrum/containers/ProductSearchPage/CLEAR_PRODUCT_LIST'
export const UPDATE_INPUT_VALUE = 'fulcrum/containers/ProductSearchPage/UPDATE_INPUT_VALUE'
export const TOGGLE_POPUP = 'fulcrum/containers/ProductSearchPage/TOGGLE_POPUP'

const listSortOrder = [
  'id',
  'segment',
  'line',
  'family',
  'platform',
  'sku',
  'brand',
  'gpuSku',
  'architecture',
  'devId',
  'devIdB'
]

export const listOrder = Object.freeze(
  listSortOrder.reduce((result, category, index) => ({
    ...result,
    [category]: index
  }), {})
)

export const PAGE = Object.freeze({
  SKU_SELECTION: 0,
  SKU_DETAILS_SELECTION: 1,
  SKU_ROLES_SELECTION: 2,
  SKU_LOADING: 3
})

const FETCH_SEGMENT_LINE = 'fulcrum/containers/ProductSearchPage/FETCH_SEGMENT_LINE'
const FETCH_SEGMENT_LINE_START = 'fulcrum/containers/ProductSearchPage/FETCH_SEGMENT_LINE_START'
const FETCH_SEGMENT_LINE_SUCCESS = 'fulcrum/containers/ProductSearchPage/FETCH_SEGMENT_LINE_SUCCESS'
const FETCH_SEGMENT_LINE_ERROR = 'fulcrum/containers/ProductSearchPage/FETCH_SEGMENT_LINE_ERROR'

const FETCH_PRODUCT_SKUS = 'fulcrum/containers/ProductSearchPage/FETCH_PRODUCT_SKUS'
const FETCH_PRODUCT_SKUS_START = 'fulcrum/containers/ProductSearchPage/FETCH_PRODUCT_SKUS_START'
const FETCH_PRODUCT_SKUS_SUCCESS = 'fulcrum/containers/ProductSearchPage/FETCH_PRODUCT_SKUS_SUCCESS'
const FETCH_PRODUCT_SKUS_ERROR = 'fulcrum/containers/ProductSearchPage/FETCH_PRODUCT_SKUS_ERROR'

const UPDATE_SEGMENT_LIST = 'fulcrum/containers/ProductSearchPage/UPDATE_SEGMENT_LIST'
const UPDATE_LINE_LIST = 'fulcrum/containers/ProductSearchPage/UPDATE_LINE_LIST'
const UPDATE_PRODUCT_SKUS = 'fulcrum/containers/ProductSearchPage/UPDATE_PRODUCT_SKUS'

const POST_FORM = 'fulcrum/containers/ProductSearchPage/POST_FORM'
const POST_FORM_START = 'fulcrum/containers/ProductSearchPage/POST_FORM_START'
const POST_FORM_SUCCESS = 'fulcrum/containers/ProductSearchPage/POST_FORM_SUCCESS'
const POST_FORM_ERROR = 'fulcrum/containers/ProductSearchPage/POST_FORM_ERROR'

export {
  FETCH_SEGMENT_LINE,
  FETCH_SEGMENT_LINE_START,
  FETCH_SEGMENT_LINE_SUCCESS,
  FETCH_SEGMENT_LINE_ERROR,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  UPDATE_SEGMENT_LIST,
  UPDATE_LINE_LIST,
  UPDATE_PRODUCT_SKUS,
  POST_FORM,
  POST_FORM_START,
  POST_FORM_SUCCESS,
  POST_FORM_ERROR,
}